import { ReactNode } from "react";
import t from "@/lang/lang";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { TableLoadingRow } from "@/shared/components/tables/table-loading-row";
import { TableRtkErrorRow } from "@/shared/components/tables/table-rtk-error-row";
import { TableCard } from "@/shared/components/tables/table-card";
import { Button } from "@/shared/components/ui/button";
import { formatDate } from "@/shared/lib/utilities/date";
import {
  ListRequest,
  useTextblocksCatalogListQuery,
} from "@/services/backend/textblocks/api/catalog-api";
import { CompanyName } from "@/services/backend/company/components/company-name";
import { CustomerName } from "@/services/backend/customers/components/customer-name";

interface Props {
  request: ListRequest;
  renderRowLink: (catalogId: string, children: ReactNode) => ReactNode;
}

export function CatalogTable({ request, renderRowLink }: Props) {
  const { data, isLoading, error } = useTextblocksCatalogListQuery(request);

  return (
    <TableCard>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t("Name")}</TableHead>
            <TableHead>{t("Unternehmen")}</TableHead>
            <TableHead>{t("Kunde")}</TableHead>
            <TableHead>{t("Beschreibung")}</TableHead>
            <TableHead>{t("Erstellt am")}</TableHead>
            <TableHead>{t("Geändert am")}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading && <TableLoadingRow colSpan={3} />}
          {error && <TableRtkErrorRow colSpan={3} error={error} />}
          {data &&
            data.items.map((catalog) => (
              <TableRow key={catalog.id}>
                <TableCell className="py-0">
                  {renderRowLink(
                    catalog.id,
                    <Button variant="link" size="sm">
                      {catalog.name}
                    </Button>,
                  )}
                </TableCell>
                <TableCell>
                  <CompanyName companyId={catalog.companyId} />
                </TableCell>
                <TableCell>
                  <CustomerName customerId={catalog.customerId ?? ""} />
                </TableCell>
                <TableCell className="max-w-md truncate">
                  {catalog.description}
                </TableCell>
                <TableCell>{formatDate(catalog.createdAt)}</TableCell>
                <TableCell>{formatDate(catalog.updatedAt)}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableCard>
  );
}
